
import { verifyOrderBillOrInwrhBill } from '@/services/forward/in/FreshReceive';
import { query } from '@/services/forward/out/Wave';
import { getPendAllocateInfo, pendAllocate } from '@/services/wcs/hangweightSowing';
export default {
  namespace: 'hangweightsowing',
  state: {
    entity: {},

  },
  effects: {
    *verifyOrderBillOrInwrhBill({ payload, callback }, { call, put }) {
      const response = yield call(verifyOrderBillOrInwrhBill, payload);
      if (callback) callback(response);
    },
    *queryWaveList({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
    *getPendAllocateInfo({ payload, callback }, { call, put }) {
      const response = yield call(getPendAllocateInfo, payload);
      if (callback) callback(response);
    },
    *pendAllocate({ payload, callback }, { call, put }) {
      const response = yield call(pendAllocate, payload);
      if (callback) callback(response);
    }
  },
  reducers: {

  }
}
